import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="text-sm text-slate2" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((it, i) => (
          <li key={it.path} className="flex items-center gap-1">
            {i > 0 && <ChevronRight size={14} className="text-slate2/50" />}
            {i < items.length - 1 ? (
              <Link to={it.path} className="hover:text-brand transition-colors">{it.name}</Link>
            ) : (
              <span className="text-ink font-medium">{it.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
